import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aw-generic-legend-dialog',
  templateUrl: './generic-legend-dialog.component.html',
  styleUrls: ['./generic-legend-dialog.component.scss']
})
export class GenericLegendDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GenericLegendDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}


  ngOnInit(): void {
    
  }


}
